module.exports = __webpack_public_path__ + "static/Abacus Data Analyser HR Dashboard Zeit-24b4abe56baad30c79600910c69cdce5.jpg";